import { OrangeButton } from "@/components/Buttons"
import { handleDownloadDocuments, handleDownloadProposals } from "../Utils/handleDownloadDocuments"
import { FaDownload } from "react-icons/fa"

export function DownloadDocumentsButton({ project_id }: { project_id: string }) {
    const handleOnClick = () => {
        handleDownloadDocuments(project_id)
    }

    return (
        <OrangeButton onClick={handleOnClick}>
            <div className="flex flex-row gap-2 items-center">
                <FaDownload />
                Download Documents
            </div>
        </OrangeButton>
    )
}

export function DownloadProposalsButton({ project_id }: { project_id: string }) {
    const handleOnClick = () => {
        handleDownloadProposals(project_id)
    }

    return (
        <OrangeButton onClick={handleOnClick}>
            <div className="flex flex-row gap-2 items-center">
                <FaDownload />
                Download Proposals
            </div>
        </OrangeButton>
    )
}